import React, { useMemo } from "react"
import { graphql, PageProps } from "gatsby"
import { ConsultingPageProps } from "../types/pages"
import PageLayout from "../layouts/page-layout"
import ServicePageLayout from "../layouts/service-page-layout"

const Consulting: React.FC<PageProps<ConsultingPageProps>> = ({ data }) => {
  const { banner, consultingContent, accordionsTexts } =
    data?.PAGE_CONTENT?.consultingOptions

  const accordions = useMemo(() => {
    return accordionsTexts?.map(acc => {
      return {
        title: acc.titileAccordions,
        description: acc.descriptionAccordions,
      }
    })
  }, [JSON.stringify(accordionsTexts)])

  return (
    <PageLayout seo={data?.PAGE_METADATA?.seo}>
      <ServicePageLayout
        banner={banner}
        pageTitle={data?.PAGE_METADATA?.title}
        content={consultingContent}
        accordions={accordions}
      />
    </PageLayout>
  )
}

export const query = graphql`
  query ($uri: String!, $locale: String!) {
    PAGE_METADATA: wpPage(
      uri: { eq: $uri }
      locale: { locale: { eq: $locale } }
    ) {
      id
      slug
      title
      link
      locale {
        locale
      }
      seo {
        metaDesc
        metaKeywords
        canonical
        opengraphDescription
        opengraphTitle
        opengraphType
        title
        twitterDescription
        twitterTitle
      }
    }
    PAGE_CONTENT: wpPage(
      uri: { eq: $uri }
      locale: { locale: { eq: $locale } }
    ) {
      consultingOptions {
        banner {
          altText
          sizes
          sourceUrl
          srcSet
        }
        consultingContent
        accordionsTexts {
          titileAccordions
          descriptionAccordions
        }
      }
    }
  }
`

export default Consulting
